
import { Component, Mixins } from "vue-property-decorator";
import { IGroupAlertBehavior } from "../../../../../../documaker/domain/format/objects";
import { IGroupAlertBehaviorPropertyEditable, instanceOfIGroupAlertBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class GroupAlertBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IGroupAlertBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IGroupAlertBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isGroupAlertBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIGroupAlertBehaviorPropertyEditable(s) && s.groupAlertBehavior().isEditable(), false);
  }

  get groupAlertBehavior(): IGroupAlertBehavior {
    return this.readPropertyOrDefault(s => s.groupAlertBehavior().getValue(), { name: "", isEnable: false });
  }

  set groupAlertBehavior(value: IGroupAlertBehavior) {
    this.writePropertyWhenValid(s => s.groupAlertBehavior().setValue(value));
  }
}
